import * as React from "react";

// Material UI components
import IconButton from '@mui/material/IconButton';

// Soft UI Dashboard PRO React components
import SoftBox from "../SoftBox";
import SoftInput from "../SoftInput";

// Icons
import { ReactComponent as SendIcon } from "../../img/icon-send.svg";

const SendMessage = ({
  disabled = false,
  handleSendClick
}) => {
  const handleFormSubmit = (e) => {
    e.preventDefault();

    const message = e.target.message.value;
    handleSendClick?.(message);
  }

  return (
    <SoftBox
      component="form"
      onSubmit={handleFormSubmit}
      autocomplete="off"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "8px",
        border: "1px solid #E4E7EC",
        backgroundColor: "#F6F7F9",
        borderRadius: "8px",
        padding: "4px 4px 4px 12px",
        "& .Mui-focused": {
          borderColor: "none !important",
          boxShadow: "none !important"
        },
        "& div": {
          width: "100%"
        },
        "& .MuiButtonBase-root": {
          backgroundColor: "var(--gmb-primary, #1B598E)",
          borderRadius: "6px",
          color: "#FFFFFF",
          width: "36px",
          height: "32px",
          fontSize: "16px",
          "&:hover": {
            backgroundColor: "var(--gmb-primary, #1B598E)",
            filter: "brightness(0.96)"
          },
          "&.Mui-disabled": {
            backgroundColor: "rgba(15,23,42,0.15)",
            color: "#FFFFFF"
          }
        }
      }}
    >
      <SoftInput
        id="message"
        name="message"
        placeholder="Write a note..."
        type="text"
        autocomplete="off"
        disabled={disabled}
        sx={{
          border: "none",
          backgroundColor: "transparent !important",
          fontSize: "13px !important",
          fontStyle: "normal",
          lineHeight: "normal",
          "& .MuiInputBase-input::placeholder": {
            color: "#98A2B3 !important",
            opacity: 1,
          },
        }}
      />

      <IconButton
        color="primary"
        type="submit"
        disabled={disabled}
      >
        <SendIcon />
      </IconButton>
    </SoftBox>
  );
}

export default SendMessage;